import { render } from "./TopicPage.vue?vue&type=template&id=6defafc5&scoped=true"
import script from "./TopicPage.vue?vue&type=script&lang=js"
export * from "./TopicPage.vue?vue&type=script&lang=js"

import "./TopicPage.vue?vue&type=style&index=0&id=6defafc5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6defafc5"]])

export default __exports__